(function(){
if(window.__quadroKitSourceReady)return;
window.__quadroKitSourceReady=true;


  var kitReadyImages = new WeakMap();
  var kitSourceSliders = new WeakSet();
  var kitSwiperStates = new WeakMap();
  var kitActiveSwipers = new Set();
  var kitObservedSliders = new WeakSet();
  var kitResizeFrame = 0;
  var kitObserver = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          kitObserver.unobserve(entry.target);
          kitActivateSlider(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' })
    : null;

  function kitActivateSlider(container) {
    if (container.classList.contains('qks-sld')) {
      kitActivateSourceSlider(container);
      return;
    }

    var slides = Array.prototype.slice.call(container.querySelectorAll('.swiper-slide'));
    var activeSlide = container.querySelector('.swiper-slide-active');
    var activeIndex = activeSlide ? slides.indexOf(activeSlide) : kitCurrentSliderIndex(container);
    kitSetActiveSlide(container, activeIndex);
  }

  function kitScheduleSlider(container) {
    var bounds = container.getBoundingClientRect();
    if (!kitObserver || bounds.width > 0 && bounds.bottom >= -400 && bounds.top <= window.innerHeight + 400) {
      if (kitObserver) {
        kitObserver.unobserve(container);
      }
      kitActivateSlider(container);
    } else if (!kitObservedSliders.has(container)) {
      kitObservedSliders.add(container);
      kitObserver.observe(container);
    }
  }

  function kitScheduleResize() {
    if (kitResizeFrame) {
      return;
    }
    kitResizeFrame = window.requestAnimationFrame(function () {
      kitResizeFrame = 0;
      kitActiveSwipers.forEach(function (container) {
        if (!container.isConnected) {
          kitActiveSwipers.delete(container);
          return;
        }
        kitSetActiveSlide(container, kitCurrentSliderIndex(container));
      });
    });
  }

  function kitSliderIndex(index, length) {
    if (!length) {
      return 0;
    }

    return ((index % length) + length) % length;
  }

  function kitCurrentSliderIndex(container) {
    var value = parseInt(container.getAttribute('data-current-slide'), 10);
    return Number.isNaN(value) ? 0 : value;
  }

  function kitSetActiveSlide(container, index) {
    var state = kitSwiperStates.get(container);
    if (!state) {
      state = {
        swiper: container.querySelector('.qks-swiper'),
        wrapper: container.querySelector('.swiper-wrapper'),
        slides: Array.prototype.slice.call(container.querySelectorAll('.swiper-slide')),
        bullets: Array.prototype.slice.call(container.querySelectorAll('.swiper-pagination-bullet'))
      };
      kitSwiperStates.set(container, state);
    }
    var swiper = state.swiper;
    var wrapper = state.wrapper;
    var slides = state.slides;
    var bullets = state.bullets;

    if (!swiper || !wrapper || !slides.length) {
      return;
    }

    var activeIndex = kitSliderIndex(index, slides.length);
    var width = Math.round(swiper.getBoundingClientRect().width || container.getBoundingClientRect().width);

    if (width <= 0) {
      return;
    }
    kitActiveSwipers.add(container);
    var sizeChanged = state.width !== width;
    var indexChanged = state.index !== activeIndex;
    if (!sizeChanged && !indexChanged) {
      return;
    }
    state.width = width;
    state.index = activeIndex;
    container.setAttribute('data-current-slide', String(activeIndex));
    wrapper.style.transitionDuration = '0ms';

    if (width > 0) {
      wrapper.style.transform = 'translate3d(' + (-width * activeIndex) + 'px, 0px, 0px)';
      if (sizeChanged) {
        slides.forEach(function (slide) {
          slide.style.width = width + 'px';
          slide.style.marginRight = '0px';
        });
      }
    }

    if (!indexChanged) {
      return;
    }
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === activeIndex;
      slide.classList.toggle('swiper-slide-active', active);
      slide.classList.toggle('swiper-slide-next', slideIndex === kitSliderIndex(activeIndex + 1, slides.length));
      slide.classList.toggle('swiper-slide-prev', slideIndex === kitSliderIndex(activeIndex - 1, slides.length));
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    bullets.forEach(function (bullet, bulletIndex) {
      var active = bulletIndex === activeIndex;
      bullet.classList.toggle('swiper-pagination-bullet-active', active);
      bullet.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function kitInitializeSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-kits-source .qks-swiper-container').forEach(kitScheduleSlider);
  }

  function kitPrepareSourceSlide(slide, priority) {
    var images = Array.prototype.slice.call(slide.querySelectorAll('img'));

    if (!images.length) {
      return Promise.resolve();
    }

    return Promise.all(images.map(function (image) {
      image.setAttribute('loading', 'eager');
      if (priority === 'high' || !image.hasAttribute('fetchpriority')) {
        image.setAttribute('fetchpriority', priority);
      }
      if (kitReadyImages.has(image)) {
        return kitReadyImages.get(image);
      }

      function markImageReady() {
        image.setAttribute('data-qks-image-ready', 'true');
      }

      function decodeImage() {
        if (typeof image.decode === 'function') {
          return image.decode().catch(function () {}).then(markImageReady);
        }
        markImageReady();
        return Promise.resolve();
      }

      var ready = image.complete ? decodeImage() : new Promise(function (resolve) {
        function finishLoading() {
          image.removeEventListener('load', finishLoading);
          image.removeEventListener('error', finishLoading);
          resolve();
        }
        image.addEventListener('load', finishLoading);
        image.addEventListener('error', finishLoading);
      }).then(decodeImage);
      kitReadyImages.set(image, ready);
      return ready;
    }));
  }

  function kitPreloadSourceSlideWindow(slider, activeIndex) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.qks-sld-item'));

    if (!slides.length) {
      return Promise.resolve();
    }

    var requestedIndexes = {};
    var targetReady = Promise.resolve();

    [-1, 0, 1].forEach(function (offset) {
      var slideIndex = kitSliderIndex(activeIndex + offset, slides.length);
      if (requestedIndexes[slideIndex]) {
        return;
      }

      requestedIndexes[slideIndex] = true;
      var ready = kitPrepareSourceSlide(slides[slideIndex], offset === 0 ? 'high' : 'auto');
      if (offset === 0) {
        targetReady = ready;
      }
    });

    return targetReady;
  }

  function kitSourceSlideIsReady(slide) {
    var images = Array.prototype.slice.call(slide.querySelectorAll('img'));
    return images.every(function (image) {
      return image.getAttribute('data-qks-image-ready') === 'true';
    });
  }

  function kitApplySourceSlide(slider, slides, activeIndex) {
    var dots = Array.prototype.slice.call(slider.querySelectorAll('.qks-sld-dot'));

    slider.setAttribute('data-current-slide', String(activeIndex));
    slider.setAttribute('aria-busy', 'false');
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === activeIndex;
      slide.classList.toggle('qks-sld-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === activeIndex;
      dot.classList.toggle('qks-sld-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function kitSetSourceSlide(slider, index) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.qks-sld-item'));

    if (!slides.length) {
      return;
    }

    var activeIndex = kitSliderIndex(index, slides.length);
    var targetSlide = slides[activeIndex];
    var currentSlide = slider.querySelector('.qks-sld-item.qks-sld-active');
    var requestNumber = parseInt(slider.getAttribute('data-slide-request'), 10) || 0;
    requestNumber += 1;
    slider.setAttribute('data-slide-request', String(requestNumber));

    var targetReady = kitPreloadSourceSlideWindow(slider, activeIndex);
    if (!currentSlide || currentSlide === targetSlide || kitSourceSlideIsReady(targetSlide)) {
      kitApplySourceSlide(slider, slides, activeIndex);
      return;
    }

    slider.setAttribute('aria-busy', 'true');
    targetReady.then(function () {
      if (slider.getAttribute('data-slide-request') !== String(requestNumber)) {
        return;
      }
      kitApplySourceSlide(slider, slides, activeIndex);
    });
  }

  function kitEnableSourceSliderDrag(slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.qks-sld-item'));
    var surface = slider.querySelector('.qks-sld-slides');

    if (!surface || slides.length < 2 || slider.getAttribute('data-drag-initialized') === 'true') {
      return;
    }

    var activePointer = null;
    var startX = 0;
    var startY = 0;
    var currentX = 0;
    var dragAxis = '';
    var dragThreshold = 40;

    slider.setAttribute('data-drag-initialized', 'true');
    slider.classList.add('qks-sld-draggable');
    surface.querySelectorAll('img').forEach(function (image) {
      image.setAttribute('draggable', 'false');
    });

    function finishDrag(event, cancelled) {
      if (activePointer === null || event.pointerId !== activePointer) {
        return;
      }

      var pointer = activePointer;
      var deltaX = currentX - startX;
      var draggedHorizontally = dragAxis === 'x' && Math.abs(deltaX) >= 8;

      activePointer = null;
      slider.classList.remove('qks-sld-dragging');

      if (surface.hasPointerCapture && surface.hasPointerCapture(pointer)) {
        surface.releasePointerCapture(pointer);
      }

      if (draggedHorizontally) {
        slider.setAttribute('data-suppress-click', 'true');
        window.setTimeout(function () {
          slider.removeAttribute('data-suppress-click');
        }, 400);
      }

      if (!cancelled && dragAxis === 'x' && Math.abs(deltaX) >= dragThreshold) {
        var currentIndex = kitCurrentSliderIndex(slider);
        kitSetSourceSlide(slider, currentIndex + (deltaX < 0 ? 1 : -1));
      }

      dragAxis = '';
    }

    surface.addEventListener('pointerdown', function (event) {
      if (activePointer !== null || event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      if (event.target.closest && event.target.closest('.qks-sld-nav-button, .qks-sld-dot, button')) {
        return;
      }

      slider.removeAttribute('data-suppress-click');
      activePointer = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      currentX = event.clientX;
      dragAxis = '';
      surface.setPointerCapture(event.pointerId);
    });

    surface.addEventListener('pointermove', function (event) {
      if (activePointer === null || event.pointerId !== activePointer) {
        return;
      }

      currentX = event.clientX;
      var deltaX = currentX - startX;
      var deltaY = event.clientY - startY;

      if (!dragAxis && (Math.abs(deltaX) >= 8 || Math.abs(deltaY) >= 8)) {
        dragAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
      }

      if (dragAxis === 'y') {
        finishDrag(event, true);
        return;
      }

      if (dragAxis === 'x') {
        slider.classList.add('qks-sld-dragging');
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    });

    surface.addEventListener('pointerup', function (event) {
      finishDrag(event, false);
    });

    surface.addEventListener('pointercancel', function (event) {
      finishDrag(event, true);
    });

    surface.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function kitActivateSourceSlider(slider) {
    if (kitSourceSliders.has(slider)) {
      return;
    }
    kitSourceSliders.add(slider);
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.qks-sld-item'));
    var activeSlide = slider.querySelector('.qks-sld-item.qks-sld-active');
    var activeIndex = activeSlide ? slides.indexOf(activeSlide) : kitCurrentSliderIndex(slider);
    kitSetSourceSlide(slider, activeIndex);
    kitEnableSourceSliderDrag(slider);
    slider.querySelectorAll('.qks-sld-nav-button, .qks-sld-dot').forEach(function (control) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
    });
  }

  function kitInitializeSourceSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-kits-source .qks-sld').forEach(function (slider) {
      slider.querySelectorAll('.qks-sld-nav-button, .qks-sld-dot').forEach(function (control) {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
      });
      kitScheduleSlider(slider);
    });

    scope.querySelectorAll('.product-kits-source .qks-box-linked[data-qks-href]').forEach(function (box) {
      box.setAttribute('role', 'link');
      box.setAttribute('tabindex', '0');
    });
  }

  function kitOpenLinkedBox(box) {
    var url = box.getAttribute('data-qks-href');
    if (!url) {
      return;
    }
    if (box.getAttribute('data-qks-href-target') === '_blank') {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = url;
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) {
      return;
    }

    var tab = event.target.closest('.product-kits-source .quadro-kit-tab');
    if (!tab) {
      var draggedSourceSlider = event.target.closest('.product-kits-source .qks-sld[data-suppress-click="true"]');
      if (draggedSourceSlider) {
        draggedSourceSlider.removeAttribute('data-suppress-click');
        event.preventDefault();
        return;
      }

      var sourceNextButton = event.target.closest('.product-kits-source .qks-sld-right');
      var sourcePrevButton = event.target.closest('.product-kits-source .qks-sld-left');
      var sourceDot = event.target.closest('.product-kits-source .qks-sld-dot');
      if (sourceNextButton || sourcePrevButton || sourceDot) {
        var sourceSlider = event.target.closest('.qks-sld');
        var sourceIndex = kitCurrentSliderIndex(sourceSlider);
        event.preventDefault();

        if (sourceNextButton) {
          kitSetSourceSlide(sourceSlider, sourceIndex + 1);
        } else if (sourcePrevButton) {
          kitSetSourceSlide(sourceSlider, sourceIndex - 1);
        } else {
          var sourceDots = Array.prototype.slice.call(sourceSlider.querySelectorAll('.qks-sld-dot'));
          kitSetSourceSlide(sourceSlider, sourceDots.indexOf(sourceDot));
        }
        return;
      }

      var nextButton = event.target.closest('.product-kits-source .qks-swiper-container > .swiper-button-next');
      var prevButton = event.target.closest('.product-kits-source .qks-swiper-container > .swiper-button-prev');
      var bullet = event.target.closest('.product-kits-source .qks-swiper-container .swiper-pagination-bullet');

      if (nextButton || prevButton || bullet) {
        var slider = event.target.closest('.qks-swiper-container');
        var currentIndex = kitCurrentSliderIndex(slider);
        event.preventDefault();

        if (nextButton) {
          kitSetActiveSlide(slider, currentIndex + 1);
        } else if (prevButton) {
          kitSetActiveSlide(slider, currentIndex - 1);
        } else {
          var bullets = Array.prototype.slice.call(slider.querySelectorAll('.swiper-pagination-bullet'));
          kitSetActiveSlide(slider, bullets.indexOf(bullet));
        }
      }

      var linkedBox = event.target.closest('.product-kits-source .qks-box-linked[data-qks-href]');
      if (linkedBox && !event.target.closest('a, button')) {
        event.preventDefault();
        kitOpenLinkedBox(linkedBox);
      }

      return;
    }

    var tabs = tab.closest('.quadro-kit-tabs');
    var block = tabs ? tabs.parentElement : null;
    var panels = block ? block.querySelectorAll('.quadro-kit-tabs-body > .quadro-kit-tab-content') : [];
    var targetId = tab.getAttribute('aria-controls');

    tabs.querySelectorAll('.quadro-kit-tab').forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('quadro-kit-tab-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var active = panel.id === targetId;
      panel.classList.toggle('quadro-kit-tab-active', active);
    });

    window.requestAnimationFrame(function () {
      kitInitializeSliders(block);
      kitInitializeSourceSliders(block);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!event.target.closest || event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    var linkedBox = event.target.closest('.product-kits-source .qks-box-linked[data-qks-href]');
    if (linkedBox) {
      event.preventDefault();
      kitOpenLinkedBox(linkedBox);
      return;
    }

    var control = event.target.closest('.product-kits-source .swiper-button-next, .product-kits-source .swiper-button-prev, .product-kits-source .swiper-pagination-bullet, .product-kits-source .qks-sld-nav-button, .product-kits-source .qks-sld-dot');
    if (!control) {
      return;
    }

    event.preventDefault();
    control.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      kitInitializeSliders(document);
      kitInitializeSourceSliders(document);
    });
  } else {
    kitInitializeSliders(document);
    kitInitializeSourceSliders(document);
  }

  window.addEventListener('load', kitScheduleResize);
  window.addEventListener('resize', kitScheduleResize);
  document.addEventListener('shopify:section:load', function (event) {
    kitInitializeSliders(event.target);
    kitInitializeSourceSliders(event.target);
  });

})();
